(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('userTasksService', userTasksService);

  function userTasksService(
    $http,
    promiseCacheService,
    ngAuthSettings
  ) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    const service = {
      getTasks: getTasks,
      getTaskDetails: getTaskDetails,
      sendActionDetails: sendActionDetails,
      getOfferParticipationTasks: getOfferParticipationTasks
    };

    return service;

    function getTasks(accountId, status) {
      const url = _serviceBaseUrl(accountId) + '?status=' + status;
      return $http.get(url); 
    }

    function getOfferParticipationTasks(accountId, campaignId, status) {
      const cacheKey = 'getOfferParticipationTasks' + campaignId + 'status' + status;
      const url = _serviceBaseUrl(accountId) + '/offers/participation/' + campaignId + '?status=' + status;
      return promiseCacheService.getCallWithCachedPromise(cacheKey, url, 30);
    }

    function getTaskDetails(accountId, jobQueueId) {
      const url = _serviceBaseUrl(accountId, jobQueueId);
      return $http.get(url);
    }

    function sendActionDetails(accountId, jobQueueId, data) {
      const url = _serviceBaseUrl(accountId, jobQueueId) + '/action';
      return $http.post(url, data); 
    }

    function _serviceBaseUrl(accountId, jobQueueId) {
      return serviceBaseUri + accountId + '/jobQueue' + (jobQueueId ? '/' + jobQueueId : '');
    }

    
  }
})();
